var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"id":"dash_op_aba_apurac_dlg_item_detalhes"},nativeOn:{"click":function($event){return _vm.$emit('openDetalhes', _vm.item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("list")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/Detalhes.vue?vue&type=template&id=5cc34bf8&
// module id = 1233
// module chunks = 28